export default __webpack_public_path__ + "../img/v_fleet_g_print_00011.jpg";